const IT = {
  acceptRequest: "Accettare la richiesta",
  accessDetail: "Dettaglio di accesso",
  accessoryUnavailable: "Accessorio(i) non disponibile(i)",
  actions: "Azioni",
  activity: "Attività",
  add: "Aggiungi",
  addAgency: "Aggiungi agenzia",
  addAgencyInfoBullet1: "Richiedere preventivi e effettuare ordini direttamente.",
  addAgencyInfoBullet2: "Beneficiare dei prezzi dei contratti quadro esistenti.",
  addAgencyInfoBullet3: "Accedere alle risorse che assegnerai.",
  addAgencyInfoTitle: "Aggiungendo questa agenzia, i tuoi clienti potranno:",
  addDocuments: "Aggiungi documenti",
  addEvent: "Aggiungi evento",
  addFile: "Aggiungi file",
  addInformation: "Aggiungi informazione",
  additionalInformation: "Informazione aggiuntiva",
  addMessageToCustomer: "Messaggio al cliente",
  addNewDocument: "Aggiungi nuovo documento",
  addParticipant: "Aggiungi partecipante",
  addResource: "Aggiungi una risorsa",
  address: "Indirizzo",
  addUser: "Aggiungi un utente",
  agencies: "Agenzie",
  agency: "Agenzia",
  agencyArchived: "Agenzia archiviata",
  agencyCreated: "Agenzia creata",
  agencyEmailDescription:
    "Tutte le notifiche relative agli ordini dell’agenzia (richiesta di preventivo, inizio noleggio, evento, reso, ecc.) saranno inviate sia agli utenti dell’agenzia sia a questo indirizzo email.",
  agencyIsRequired: "Agenzia obbligatoria",
  agencyName: "Nome agenzia",
  agencyUpdated: "Agenzia aggiornata",
  allFilesUpToDate: "Tutti i file sono aggiornati",
  allMyOrders: "Tutti i miei ordini",
  allResources: "Tutte le risorse",
  alreadyCustomer: "Già cliente?",
  analytics: "Analisi",
  anErrorOccurred: "Si è verificato un errore",
  apiStatus: "Stato API",
  applicant: "Richiedente",
  applicationVersion: "Versione applicazione",
  archive: "Archivia",
  archive_one: "{{count}} Archivio",
  archive_other: "{{count}} Archivi",
  archiveAgency: "Archivia agenzia",
  archiveAgencyConfirmation:
    "Sei sicuro di voler archiviare l'agenzia {{name}}? Tutti i contratti correlati verranno archiviati e le richieste di prenotazione in sospeso verranno annullate.",
  archived: "Archiviata",
  areYouAConstructionCompany: "Sei un'impresa edile?",
  areYouSureYouWantDetachResource: "Sei sicuro di voler scollegare la risorsa da questo ordine?",
  areYouSureYouWantDetachUser: "Sei sicuro di voler scollegare questo utente dall'agenzia? Questo utente sarà avvisato via e-mail.",
  areYouSureYouWantToDelete: "Sei sicuro di voler eliminare?",
  areYouSureYouWantToDeleteWithItem: "Sei sicuro di voler eliminare {{item}}?",
  article: "Articolo",
  articleAccess: "Accesso all'articolo",
  articleCategory: "Categoria",
  articleEquipmentUpdated: "Attrezzatura dell'articolo aggiornata",
  articleInformation: {
    message: "Scegli una macchina dal tuo parco interno o un operatore",
    warningDescription:
      "Informazioni sull'attrezzatura mancanti. Fornire i documenti e le informazioni richieste prima dell'inizio del noleggio.",
    warningTitle: "Informazioni sull'attrezzatura mancanti",
  },
  articleNameIsRequired: "Il nome dell'articolo è obbligatorio",
  articles: "Articoli",
  assignment: "Assegnazione",
  associatedMachine: "Macchina associata",
  attachAResource: "Seleziona una risorsa",
  attachResource: "Collega una risorsa",
  availability: "Disponibilità",
  available: "Disponibile",
  backToLogin: "Torna al login",
  beginning: "Inizio",
  between: "tra",
  billing: "Fatturazione",
  billingDetailsAssociatedWithThisOrder: "Dettagli di fatturazione associati a questo ordine",
  billings: "Fatturazioni",
  booking: {
    addAnItem: "Aggiungi un articolo",
    automaticExtension: "Estensione automatica",
    bankingHolidays: "Giorni festivi",
    date: "Data prenotazione",
    day: "Giorno",
    days: "Giorni",
    fromDate: "Data di inizio",
    saturday: "Sabato",
    sunday: "Domenica",
    toDate: "Data di fine",
    useOn: "Usa su:",
  },
  bookingDate: "{{fromDate}} a {{toDate}}",
  bookingEnd: "Fine prenotazione",
  bookingStart: "Inizio prenotazione",
  bookingStartTomorrow: "La prenotazione inizia domani",
  bookingStartTomorrowMessage:
    "Assicurati che tutto sia pronto per la consegna, rispettando i vincoli del cliente e includendo gli accessori richiesti se necessario.",
  bookings: "Prenotazioni",
  brand: "Marca",
  brandIsRequired: "La marca è obbligatoria",
  breadcrumbs: {
    booking: {
      requests: "n°{{id}}",
    },
  },
  by: "da",
  byFile: "per file",
  cancel: "Annulla",
  canceled: "Annullato",
  category: "Categoria",
  categoryName: "Nome categoria",
  ceCertificate: "Certificato CE",
  changePasswordAccount: "Cambia la password del tuo account Tracktor",
  chat: "Chatta",
  clickToUpload: "Clicca per caricare",
  client: "Cliente",
  clientRequest: "Richiesta del cliente",
  clients: "Clienti",
  clientWillBeNotifiedByEmail: "L’utente invitato sarà notificato via e-mail.",
  close: "Chiudi",
  closed: "Chiuso",
  closedAt: "Chiuso il {{date}}",
  closedAtIncidentAlert: "Chiuso il {{date}} da {{by}}",
  closeTheIncident: "Chiudi l'incidente",
  code: "Codice",
  codeOrKeysLocation: "Codice o posizione delle chiavi",
  commandPosts: "Posti di comando",
  company: "Azienda",
  completed: "Completato",
  confirm: "Conferma",
  confirmed: "Confermato",
  contactAction: "Contattare",
  contacts: "Contatti",
  continue: "Continua",
  couldNotFindBookingItem: "Impossibile trovare l'articolo della prenotazione",
  countryCode: "Prefisso internazionale",
  createAPasswordForYourAccount: "Crea una password per il tuo account",
  createNewResource: "Crea una nuova risorsa",
  createNewUser: "Crea un nuovo utente",
  createYourFirstConversation: "Crea la tua prima conversazione",
  currentApiVersion: "Versione API attuale",
  currentApiVersionUsed: "Versione API utilizzata",
  darkMode: "Modalità scura",
  darkTheme: "Tema scuro",
  dashboard: "Dashboard",
  dataSheet: "Scheda tecnica",
  date: {
    endDate: "Data di fine",
    startDate: "Data di inizio",
  },
  dates: "Date",
  dayCount_one: "{{count}} Giorno",
  dayCount_other: "{{count}} Giorni",
  deals: "Offerte",
  dealsView: {
    detailed: "Dettagliato",
    grouped: "Raggruppato",
    kanban: "Kanban",
    list: "Elenco",
    planning: "Pianificazione",
  },
  delete: "Elimina",
  deleteBookingFileMessage: "Sei sicuro di voler eliminare questo file dalla prenotazione?",
  deleteConversation: "Elimina conversazione",
  deleteFile: "Elimina file",
  deleteFileConfirmation: "L'eliminazione del file è irreversibile. Sei sicuro di voler continuare?",
  deleteResource: "Elimina risorsa",
  deleteResourceConfirmation:
    "L'eliminazione di una risorsa è irreversibile e cancellerà tutti i file collegati. Sei sicuro di voler continuare?",
  delivery: "Consegna",
  deliveryAndReturn: "Consegna e restituzione",
  deliveryTimeConstraint: "Vincolo orario di consegna",
  designation: "Designazione",
  detach: "Scollega",
  detachResource: "Scollega risorsa",
  detachUser: "Scollega utente",
  detachUserSuccessfully: "Utente scollegato con successo",
  document: "documento",
  documentAdded: "Documento aggiunto",
  documentDeleted: "Documento eliminato",
  documentExp: "Doc. scad.",
  documentIssue_one: "{{count}} doc da fornire",
  documentIssue_other: "{{count}} doc da fornire",
  documentIssueTooltip_one: "{{count}} documento mancante o scaduto",
  documentIssueTooltip_other: "{{count}} documenti mancanti o scaduti",
  documentMissing_one: "{{count}} doc mancante",
  documentMissing_other: "{{count}} doc mancanti",
  documentName: "Nome documento",
  documents: "Documenti",
  documentsOk: "Doc OK",
  documentType: "Tipo di documento",
  documentUpdated: "Documento aggiornato",
  edit: "Modifica",
  editInfoDocument: "Modifica informazioni documento",
  editMyPassword: "Modifica la mia password",
  editResource: "Modifica risorsa",
  editUser: "Modifica utente",
  email: "Email",
  emailSent: "Email inviata",
  emailSentForgotPassword: "È stata inviata un'email per reimpostare la password.",
  emptyBooking: "Non hai prenotazioni imminenti",
  emptyBookingMissing: "Non hai richieste perse",
  emptyState: {
    noDealsFound: "Non hai ancora alcun ordine",
    noDealsFoundDescription: "I tuoi nuovi ordini verranno visualizzati in questa tabella.",
    pageNotFoundDescription: "La pagina che stai cercando non è stata trovata. Controlla l'URL o torna alla pagina precedente.",
    returnToOrders: "Torna agli ordini",
  },
  end: "Fine",
  enterTheCode: "Inserisci il codice",
  enterToSend: "↵ Invio per inviare · ⇧ Shift+↵ Invio per nuova riga",
  enterYourCode: "Inserisci il tuo codice",
  enterYourMessage: "Inserisci il tuo messaggio",
  entity: "Entità",
  equipment: "Attrezzatura",
  equipmentInformation: {
    maximumPlates: "Carico massimo sul pattino (T)",
    sizePlates: "Dimensione delle piastre di distribuzione (m²)",
    skid: "Pressione massima sotto la piastra di distribuzione (T/m²)",
  },
  equipmentNotOffered: "Attrezzatura non offerta",
  error: {
    missingArticle: "Articolo mancante",
    missingDates: "Date mancanti",
    missingQuantity: "Quantità mancante",
    missingUnitPrice: "Prezzo unitario mancante",
    noBookingFound: "Nessuna prenotazione trovata",
    noClientFoundForThisRequest: "Nessun cliente trovato per questa richiesta",
    pleaseFillFields: "Per favore, compila tutti i campi obbligatori",
    pleaseSelectArticleBeforeAddingNewOne: "Seleziona un articolo prima di aggiungerne uno nuovo",
    positiveValueOnly: "Sono consentiti solo valori positivi",
    resourceMustBeSelected: "Devi selezionare una risorsa",
    selectDates: "Seleziona le date di inizio e fine",
    shouldBeANumber: "Questo campo deve essere un numero",
    someRequestDataAreMissing: "Alcuni dati della richiesta sono mancanti",
    unknownError: "Errore sconosciuto, riprova",
  },
  error404: "Errore 404",
  errorLoadingRequests: "Si è verificato un errore durante il caricamento delle richieste",
  escape: "Esc",
  eventStatus: {
    accepted: "Richiesta di noleggio accettata",
    canceled: "Richiesta di noleggio annullata",
    refused: "Richiesta di noleggio rifiutata",
    sent: "Richiesta di noleggio ricevuta",
  },
  eventUpdated: "Evento aggiornato",
  expirationDate: "Data di scadenza",
  expired: "Scaduto",
  file: "il documento",
  fileAddedSuccessfully: "File aggiunto con successo",
  fileArchivedSuccessfully: "File archiviato con successo",
  fileDeletedSuccessfully: "File eliminato con successo",
  fileHasBeenUploaded: "Il file è stato caricato",
  fileName: "Nome file",
  fileStatus: {
    expired: "Scaduto",
    expires_soon: "In scadenza",
    up_to_date: "Aggiornato",
  },
  files: "File",
  filesNotUpToDate: "Alcuni file non sono aggiornati",
  fileType: "Tipo di file",
  fileUnarchivedSuccessfully: "File dearchiviato con successo",
  finish: "Fine",
  finishDayCount: "Questo termine termina tra {{count}} giorni",
  finishToday: "Termina oggi",
  finishTomorrow: "Termina domani",
  firstName: "Nome",
  flatRate: "Tariffa fissa",
  fleetNumber: "Numero di parco",
  forgottenPassword: "Password dimenticata",
  forgottenPasswordSubtitle: "Inserisci la tua email. Ti invieremo un link per reimpostare la password",
  form: {
    constraint: {
      password: "La password deve contenere almeno 8 caratteri e una lettera maiuscola",
    },
    validation: {
      required: "Questo campo è obbligatorio",
    },
  },
  generalTerms: "Termini generali",
  getSupport: "Ottieni supporto",
  giveFeedback: "Fornisci feedback",
  globalSearchPlaceholder: "Inserisci un ID offerta o nome articolo",
  happyToSeeYouAgain: "Felice di rivederti!",
  help: "Aiuto",
  helperText: {
    onlyImageFilesAreAllowed: "Sono consentiti solo file .png, .jpeg, .pdf",
  },
  history: "Storico",
  home: "Home",
  icon: "Icona",
  identity: "Identità",
  identityCard: "Carta d'identità",
  import: "Importa",
  importFile: "Importa file",
  incidentAddedSuccessfully: "Incidente aggiunto con successo",
  incidentClosed: "Incidente chiuso",
  incidentOpened: "Incidente aperto",
  indicateCodeOrKeysLocation: "Indica il codice o la posizione delle chiavi",
  information: "Informazione",
  informations: "Informazioni",
  inProgress: "In corso",
  instructionManual: "Manuale d'istruzioni",
  insurance: "Assicurazione",
  internalCode: "Codice interno",
  internalCodeIsRequired: "Il codice interno è obbligatorio",
  invoice: "Fattura",
  irreversibleAction: "Questa azione è irreversibile",
  key: "Chiave",
  keyLocation: "Posizione chiave",
  keys: "Chiavi",
  language: "Lingua",
  lastName: "Cognome",
  linkDocuments: "Collega documenti",
  linkDocumentsToBooking: "Documenti visibili al cliente",
  list: "Lista",
  logIn: "Accedi",
  login: "Accedi",
  logout: "Disconnetti",
  machine: "Macchina",
  machineRegistration: "Registrazione macchina",
  mail: "Email",
  maintenanceLog: "Registro manutenzione",
  makeAnOffer: "Fai un'offerta",
  material: "Materiale",
  materialDropOffPoint: "Punto di consegna materiale",
  messagePlaceholder: "Carico massimo al pattino (T), dimensioni delle piastre di ripartizione (m²)…",
  messages: "Messaggi",
  messageToCustomer: "Messaggio al cliente",
  missed: "Perso",
  missingRole: "Ruolo mancante",
  modifyMyOffer: "Modifica la mia offerta",
  modifyOffer: "Modifica offerta",
  myProfile: "Il mio profilo",
  name: "Nome",
  newConversation: "Nuova conversazione",
  newDate: "Nuova data",
  newDateProposal: "Disponibile da un'altra data vicina",
  newDocument: "Nuovo documento",
  newMessage: "Nuovo messaggio",
  newMessageCount_one: "{{count}} nuovo messaggio",
  newMessageCount_other: "{{count}} nuovi messaggi",
  newPassword: "Nuova password",
  newPasswordConfirm: "Conferma nuova password",
  newResourceCreated: "La tua nuova risorsa è stata creata!",
  newResourceCreatedDetails: "Carica documenti e le relative date di validità.",
  next: "Avanti",
  nextAssignment: "Prossima assegnazione",
  no: "No",
  noAgenciesFound: "Nessuna agenzia trovata",
  noAvailability: "Nessuna disponibilità e downgrade impossibile",
  noDocumentsFound: "Nessun documento trovato",
  noEvents: "Nessun evento",
  noFilesAttached: "Nessun file allegato",
  noNameFound: "Nessun nome trovato",
  noOrderFound: "Nessun ordine associato a questo articolo trovato",
  notAvailable: "Non disponibile",
  notes: "Note",
  notFound: "La pagina che cerchi non è stata trovata.",
  notFoundRedirection: "Controlla l'URL o torna alla pagina precedente.",
  noUsersFound: "Nessun utente trovato",
  num: "N°",
  numberOfDays: "Numero di giorni",
  numberParc: "N° di parco",
  numberParcShort: "N° parco",
  offerSendTo: "La tua offerta è stata inviata a {{name}}",
  offerSendToDetails: "Sarai avvisato non appena il cliente approverà la tua offerta.",
  onboarding: {
    featureRequests: {
      step1Description:
        "I clienti vedono immediatamente su Tracktor i fornitori più vicini al loro cantiere, classificati per distanza e prezzi da contratto quadro.",
      step1Title: "Aumentate i vostri ricavi",
      step2Description:
        "Compilate il vostro preventivo e inviatelo. Rispondendo rapidamente con un prezzo vantaggioso, aumentate le vostre possibilità di essere scelti dal cliente!",
      step2Title: "Rispondete in pochi clic",
    },
  },
  open: "Aperto",
  openFullPage: "Apri a pagina intera",
  openFullScreen: "Apri a schermo intero",
  operator: "Operatore",
  operatorDocExp: "Oper. scad.",
  operatorDocKo: "Oper. KO",
  operatorDocMissing_one: "{{count}} oper. mancante",
  operatorDocMissing_other: "{{count}} oper. mancanti",
  operatorDocument: "Documento operatore",
  order: "Ordine",
  orderHistory: "Storico ordini",
  orderSummary: "Riepilogo ordine",
  orders: "Ordini",
  other: "Altro",
  oups: "Ops!",
  overview: "Panoramica",
  pageNotFound: "Pagina non trovata",
  participants: "Partecipanti",
  password: "Password",
  passwordSetSuccessfully: "La tua password è stata aggiornata",
  passwordsNotMatching: "Le password non corrispondono",
  passwordUpdated: "La tua password è stata aggiornata",
  payments: "Pagamenti",
  periodicGeneralInspection: "Ispezione generale periodica (PGI)",
  phone: "Telefono",
  phoneNumber: "Numero di telefono",
  planning: "Pianificazione",
  pleaseSetAPassword: "Imposta una password",
  price: "Prezzo",
  priceExVAT: "IVA esclusa",
  profile: "Il mio profilo",
  profileUpdated: "Il tuo profilo è stato aggiornato",
  purchaseOrder: "Ordine di acquisto",
  purchaseOrderNumber: "Numero ordine di acquisto",
  quantity: "Quantità",
  quote: "Preventivo",
  reason: "Motivo",
  received: "Ricevuto",
  refuse: "Rifiuta",
  refused: "Rifiutato",
  refusedBookingRequestMessage: "Confermando il rifiuto di questa richiesta di prenotazione, non potrai accettarla successivamente.",
  refusedTheBooking: "Ordine rifiutato",
  refuseRequest: "Rifiutare la richiesta",
  releaseNotRequested: "Il cliente non ha ancora richiesto il rilascio",
  releaseRequestedForDate: "Rilascio richiesto per il {{date}}",
  reload: "Ricarica",
  rentalRequests: "Richieste",
  reopenTheIncident: "Riapri l'incidente",
  replace: "Sostituisci",
  request: "Richiesta",
  requestMissedAlert: {
    button: "Torna alle mie richieste",
    description1: "Il cliente ha inviato questa richiesta a diversi fornitori e ha accettato una delle loro offerte.",
    description2:
      "Su Tracktor, i fornitori rispondono in media in meno di un’ora: sii reattivo per massimizzare le tue possibilità di ottenere nuove opportunità.",
    redirection: "👉 Scopri di più sulla ricerca dei fornitori su Tracktor",
    title: "Richieste perse",
  },
  requestOfferAlertInfoDescription:
    "Rispondere a ogni richiesta (anche con un rifiuto) aumenta del 65% le possibilità di essere ricontattato da questo cliente.",
  requestOfferAlertInfoTitle: "Non perdere nessuna opportunità",
  requestStatus: {
    expired: "Scaduto",
    proposed: "Proposto",
    refused: "Rifiutato",
    toTreat: "Da trattare",
  },
  requests: "Richieste",
  requestWithID: "Richieste n°{{id}}",
  required: "Obbligatorio",
  reservation: "Prenotazione",
  reservationRequestAccepted: "Richiesta di prenotazione accettata, l'ordine è stato creato",
  reservationRequestInfo:
    "Accettando, questa richiesta sarà trasformata automaticamente in un ordine alle condizioni indicate sopra. Apparirà nei tuoi Ordini e il cliente sarà informato.",
  resetInitialRequest: "Reimposta richiesta iniziale",
  resetPassword: "Reimposta password",
  resource: "Risorsa",
  resourceAddedSuccessfully: "Risorsa aggiunta con successo",
  resourceCreated: "Risorse create",
  resourceDetachedSuccessfully: "Risorsa scollegata con successo",
  resourceEmptyState: {
    button: "Aggiungi la tua prima risorsa",
    dialogContentText: "Aggiungi più risorse contemporaneamente importando un file (CSV, XLS, XLSX, PDF...) o aggiungile manualmente.",
    dialogPrimaryButton: "Aggiungi manualmente",
    dialogSecondaryButton: "Importa un file",
    dialogSuccessContentText:
      "L'elaborazione delle tue risorse è in corso. Saranno presto disponibili nel tuo spazio e riceverai una conferma via email.",
    dialogSuccessTitle: "Risorse trasferite",
    dialogTitle: "Scegli il tuo metodo",
    listSubtitle1: "Aggiungi una nuova risorsa al tuo spazio",
    listSubtitle2: "E specifica le date di validità",
    listSubtitle3: "Tutti i documenti saranno inviati al cliente",
    listTitle1: "Salva una risorsa",
    listTitle2: "Aggiungi documenti",
    listTitle3: "Assegna a un ordine",
    title: "Aggiungi la tua prima risorsa e semplifica la gestione dei tuoi ordini",
  },
  resourceName: "Nome risorsa",
  resourcePhoto: "Foto risorse",
  resourcePhotoHelperText: "PNG o JPG (max. 5 MB)",
  resourceSearchPlaceholder: "Digita per cercare (modello, numero di parco)",
  resources: "Risorse",
  resourceUpdated: "Risorse aggiornate",
  resourceUpdatedSuccessfully: "Risorsa aggiornata con successo",
  respondToDemand: "Rispondi alla richiesta",
  return: "Restituzione",
  returnTo: "Torna a",
  role: "Ruolo",
  save: "Salva",
  saveChanges: "Salva modifiche",
  search: "Cerca",
  searchContacts: "Cerca contatti",
  searchInApp: "Cerca nell'app",
  see: "Vedi",
  seeDetail: "Vedi dettaglio",
  seeOffer: "Vedi offerta",
  seeTheLines: "Vedi le righe",
  seeTheResource: "Vedi la risorsa",
  selectAnAgency: "Seleziona un'agenzia",
  selectAnAgencyToAttachCategory: "Seleziona un'agenzia per collegare questa categoria",
  selectAnotherResource: "Seleziona un'altra risorsa",
  selectDocumentType: "Seleziona il tipo di documento",
  selectExpirationDate: "Seleziona la data di scadenza",
  selectResource: "Seleziona la risorsa",
  selectResourceWarning:
    "Selezionando questa risorsa, confermi che soddisfa le esigenze del cliente. Il cliente verrà notificato via e-mail.",
  send: "Invia",
  sendOffer: "Invia offerta",
  sent: "Inviato",
  serialNumber: "Numero di serie",
  service: "Servizio",
  settings: "Parametri",
  siret: "SIRET / Numero DNS",
  siretMustBe14Characters: "Il SIRET deve contenere esattamente 14 caratteri",
  sorenAnnouncement: {
    badge: "Presto Soren",
    badgeSwitched: "Ora Soren",
    badgeSwitchedTooltip: "Tracktor ora è Soren — scopri di più",
    badgeTooltip: "Tracktor diventa Soren — scopri di più",
    gotIt: "Capito",
    readArticle: "Leggi l'annuncio",
    story: {
      goToCard: "Scheda {{count}}",
      nextCard: "Scheda successiva",
      previousCard: "Scheda precedente",
      switchTitle: "Tracktor cambia nome entro il {{date}}.",
      switchTitlePast: "Tracktor ha cambiato nome il {{date}}.",
      switchTitleToday: "Tracktor cambia nome oggi.",
      thanksBody: "Per le tue macchine, le tue squadre e la tua fiducia.",
      thanksBodyOrders_one: "{{number}} ordine insieme. Per le tue macchine, le tue squadre e la tua fiducia.",
      thanksBodyOrders_other: "{{number}} ordini insieme. Per le tue macchine, le tue squadre e la tua fiducia.",
      thanksTitle: "Grazie, {{name}}.",
      thanksTitleAnonymous: "Grazie.",
    },
    unchanged: {
      accessTitle: "Stessi accessi",
      contactsTitle: "Stessi interlocutori",
      ordersTitle: "Stessi ordini e clienti",
      title: "Non cambia nulla a parte il nome e il logo.",
    },
  },
  startDayCount: "Inizia tra {{count}} giorni",
  startToday: "Inizia oggi",
  startTomorrow: "Inizia domani",
  status: "Stato",
  supplier: "Fornitore",
  supplierComment: "Commento fornitore",
  TECHNICAL_SHEET: "Scheda tecnica",
  theBookingRequestHasBeenAccepted: "La tua offerta è stata inviata",
  theBookingRequestHasBeenRefused: "La richiesta di prenotazione è stata rifiutata",
  to: "A",
  to_add: "Da aggiungere",
  toAdd: "Da aggiungere",
  toCome: "In arrivo",
  toDo: "Da fare",
  today: "Oggi",
  tokenVerification: "Verifica token",
  total: "Totale",
  totalHT: "Totale IVA esclusa",
  toUpdate: "Da aggiornare",
  type: "Tipo",
  typeToSearch: "Digita per cercare",
  unarchive: "De-archivia",
  units: {
    DAYS_one: "{{count}} Giorno",
    DAYS_other: "{{count}} Giorni",
    HOURS_one: "{{count}} Ora",
    HOURS_other: "{{count}} Ore",
    KM: "{{count}} Km",
    null: "{{count}} ",
    unit: "Unità",
    units: "Unità",
    units_one: "{{count}} Unità",
    units_other: "{{count}} Unità",
  },
  up_to_date: "Aggiornato",
  uploadFile: "Carica file",
  upToDate: "Aggiornato",
  userHasBeenAttachedToAgency: "L'utente è stato collegato all'agenzia",
  users: "Utenti",
  usersActions: {
    archiveUser: "Archivia utente",
    archiveUserSuccessfully: "Utente archiviato con successo",
    areYouSureYouWantToArchiveThisUser:
      "Sei sicuro di voler archiviare questo utente? Questo utente non avrà più accesso allo spazio dell'agenzia e verrà notificato via e-mail.",
    unarchiveUser: "Ripristina utente",
    unarchiveUserDescription: "Ripristinando questo utente, riacquisterà l'accesso allo spazio dell'agenzia e verrà notificato via e-mail.",
    unarchiveUserSuccessfully: "Utente ripristinato con successo",
    userCreatedSuccessfully: "Utente creato con successo",
    userUpdatedSuccessfully: "Utente aggiornato con successo",
  },
  userUnarchivedSuccessfully: "Utente dearchiviato con successo",
  validate: "Valida",
  worksiteAccessConstraints: "Vincoli di accesso al cantiere",
  writeAMessage: "Scrivi un messaggio...",
  yes: "Sì",
  yesterday: "Ieri",
  yourAccount: "Il tuo account",
  yourClientWillBeNotifiedByEmail: "Il tuo cliente sarà notificato via e-mail.",
  yourOffer: "La sua offerta",
  yourOrdersAreWaitingForYouLogin: "I tuoi ordini ti aspettano, accedi!",
  yourResourcesWillBeAddedToYourSpaceAfterProcessing: "Le tue risorse saranno aggiunte al tuo spazio dopo l'elaborazione",
} as const;

export default IT;
